const HYGIENE_PAGE_SIZES = [5, 10, 20];

export { HYGIENE_PAGE_SIZES };
